/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { WithMember } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import { UserProfile } from "./user-profile";
import { connect } from "react-redux";
import { accessCheck } from "../../utils";

const HeaderLoginBase = props => {
  const { openLoginTemplate, closeLoginTemplate, headerTheme, enableSSO, localizedElementsData } = props;
  const { signIn: localizedSignIn } = localizedElementsData;
  const headerType = headerTheme.includes("single-layer") ? "single-layer" : "";

  if (!accessCheck(enableSSO)) return null;
  return (
    <WithMember>
      {({ member, logout, isLoading, checkForMemberUpdated }) => (
        <UserProfile
          openLoginTemplate={openLoginTemplate}
          closeLoginTemplate={closeLoginTemplate}
          member={member}
          logout={logout}
          isLoading={isLoading}
          checkForMemberUpdated={checkForMemberUpdated}
          customCssClasses={headerType}
          localizedSignIn={localizedSignIn}
        />
      )}
    </WithMember>
  );
};

HeaderLoginBase.propTypes = {
  openLoginTemplate: PropTypes.bool,
  closeLoginTemplate: PropTypes.bool,
  headerTheme: PropTypes.string,
  enableSSO: PropTypes.bool,
  localizedElementsData: PropTypes.shape({
    signIn: PropTypes.string
  })
};

const mapStateToProps = state => {
  const { enableLocalization = false, localizedElements = {} } = get(
    state.qt,
    ["config", "pagebuilder-config", "general", "localization"],
    {}
  );
  return {
    headerTheme: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "headerStyle"],
      get(state.qt, ["config", "theme-attributes", "header_theme"], "header_1")
    ),
    enableSSO: get(
      state.qt,
      ["config", "pagebuilder-config", "header", "enableSSO"],
      get(state.qt, ["config", "theme-attributes", "enableSSO"], false)
    ),
    localizedElementsData: enableLocalization ? localizedElements : {}
  };
};

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" }),
  closeLoginTemplate: () => dispatch({ type: "CLOSE_LOGIN_TEMPLATE" })
});

export const HeaderLogin = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderLoginBase);

export { HeaderLoginBase };
